module.exports = __webpack_public_path__ + "img/pic9.e28fb9e7.png";